import React from 'react';
import {
  Card,
  CardContent,
  CircularProgress,
  Container,
  Divider,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { useCallback, useEffect, useMemo, useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import * as Survey from 'survey-react';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  BultenDetay: {
    marginTop: theme.spacing(1)
  },
  value: {
    fontWeight: theme.typography.fontWeightMedium
  },
  type: {
    fontWeight: theme.typography.fontWeightMedium
  },
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
  searchButton: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));

function InstallForm({
  Id,
  FisNo,
  className,
  userModelCode,
  onClose,
  onFormComplete
}) {
  const classes = useStyles();
  const [anketData, setAnketData] = useState({});
  const [formData, setFormData] = useState({});
  const [anketBitti, setAnketBitti] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mesaj, setMesaj] = useState('Form Başarıyla Tamamlandı.');

  const handleAnketBitti = useCallback(
    (MesajParam = 'Form Başarıyla Kaydedildi.') => {
      setAnketBitti(true);
      setMesaj(MesajParam);

      // Form başarıyla kaydedildiyse parent component'e bildir
      if (MesajParam === 'Form Başarıyla Kaydedildi.' && onFormComplete) {
        onFormComplete();
      }
    },
    [onFormComplete]
  );

  const GetArtemisForm = useCallback(async () => {
    setLoading(true);

    try {
      const isNormalForm = FisNo !== undefined && Id !== 1000;

      const url = isNormalForm
        ? `GetArtemisForm/${Id}/${FisNo}`
        : `GetArtemisFormMontaj/${Id}/${FisNo}/${userModelCode}`;

      const { data: res } = await axios.get(url);

      if (typeof res === 'string') {
        handleAnketBitti(res);
        return;
      }

      const jsonStr = res?.[0]?.json;
      const formDataStr = res?.[0]?.FormData;

      if (!jsonStr || jsonStr === 'undefined' || jsonStr === 'null') {
        handleAnketBitti('Form verileri alınamadı. Lütfen tekrar deneyiniz.');
        return;
      }

      let anketData;
      let formData = {};

      try {
        anketData = JSON.parse(jsonStr);
      } catch (err) {
        console.warn('Form JSON parse hatası:', err.message);
        handleAnketBitti('Form verisi okunamadı. Lütfen tekrar deneyiniz.');
        return;
      }

      if (
        formDataStr &&
        formDataStr !== 'undefined' &&
        formDataStr !== 'null'
      ) {
        try {
          formData = JSON.parse(formDataStr);
        } catch (err) {
          console.warn('FormData JSON parse hatası:', err.message);
        }
      }

      if (!anketData?.pages) {
        handleAnketBitti('Merkezden Form Bilgileri Alınamadı!..');
        return;
      }

      setAnketData(anketData);
      setFormData(formData);
    } catch (error) {
      console.warn('Form yükleme hatası:', error.message);
      handleAnketBitti(
        'Form yüklenirken bir hata oluştu. Lütfen tekrar deneyiniz.'
      );
    } finally {
      setLoading(false);
    }
  }, [FisNo, Id, userModelCode, handleAnketBitti]);

  useEffect(() => {
    GetArtemisForm(Id, FisNo);
  }, [GetArtemisForm, Id, FisNo]);

  // Form başarıyla kaydedildiğinde otomatik kapat
  useEffect(() => {
    if (anketBitti && mesaj === 'Form Başarıyla Kaydedildi.') {
      const timer = setTimeout(() => {
        if (onClose) {
          onClose();
        }
      }, 1000); // 1 saniye sonra popup'ı kapat

      return () => clearTimeout(timer);
    }
  }, [anketBitti, mesaj, onClose]);

  const onComplete = useCallback(
    survey => {
      setLoading(true);
      const data = {
        Data: survey.data,
        FormTipi: Id,
        FisNo: FisNo
      };

      const config = {
        headers: { 'Content-Type': 'application/json' }
      };
      axios
        .post('/SetArtemisForm', { jsonString: JSON.stringify(data) }, config)
        .then(() => {
          handleAnketBitti();
          setLoading(false);
        });
    },
    [Id, FisNo, handleAnketBitti]
  );

  const defaultThemeColors = Survey.StylesManager.ThemeColors.default;
  defaultThemeColors['$main-color'] = '#FF9800';
  defaultThemeColors['$main-hover-color'] = '#FF9800';
  defaultThemeColors['$text-color'] = '#424242';

  Survey.StylesManager.applyTheme();

  // Model'i useMemo ile oluştur
  const model = useMemo(() => {
    const surveyModel = new Survey.Model(anketData);
    surveyModel.locale = 'tr';

    // Montaj kontrol onayı için stil değişikliği
    surveyModel.onValueChanged.add((sender, options) => {
      if (options.name === 'ana_onay') {
        const listElement = document.getElementById('wrapper_list');
        const listItems = document.querySelectorAll('#checkList li');

        if (listElement && listItems.length > 0) {
          // Hem checkbox (array) hem radiogroup (string) desteği
          const isApproved =
            (Array.isArray(options.value) &&
              options.value.includes('onaylandi')) ||
            options.value === 'onaylandi';

          if (isApproved) {
            // Başarılı durumu: Yeşil ve onay işaretli
            listElement.style.color = '#16a34a';
            listElement.style.backgroundColor = '#f0fdf4';
            listElement.style.fontWeight = '600';

            // Her liste elemanına tik işareti ekle
            listItems.forEach(item => {
              if (!item.textContent.startsWith('✔')) {
                item.style.color = 'green';
                item.textContent = '✔ ' + item.textContent;
              }
            });
          } else {
            // Geri alma durumu: Standart renkler
            listElement.style.color = 'initial';
            listElement.style.backgroundColor = 'transparent';
            listElement.style.fontWeight = 'normal';

            // Tik işaretlerini kaldır
            listItems.forEach(item => {
              item.style.color = 'initial';
              if (item.textContent.startsWith('✔ ')) {
                item.textContent = item.textContent.substring(2);
              }
            });
          }
        }
      }
    });

    // onComplete event'ini model'e ekle
    surveyModel.onComplete.add(onComplete);

    return surveyModel;
  }, [anketData, onComplete]);

  // FormData değiştiğinde model data'sını güncelle
  useEffect(() => {
    if (model && formData && Object.keys(formData).length > 0) {
      model.data = formData;
    }
  }, [model, formData]);

  return (
    <Page className={classes.root}>
      <Container maxWidth="lg">
        <Card className={clsx(classes.root, className)}>
          {' '}
          <Divider />
          {FisNo ? (
            <div className={classes.content}>
              {loading && (
                <CircularProgress
                  status={'loading'}
                  style={{ marginLeft: '50%' }}
                />
              )}
              {!loading && anketBitti && (
                <CardContent className={classes.content}>
                  <Typography variant="h5" gutterBottom>
                    {mesaj}
                  </Typography>
                </CardContent>
              )}
              {!loading && !anketBitti && (
                <Survey.Survey
                  model={model}
                  completeText="Formu Tamamla"
                  emptySurvey="Uygun Form Bulunamadı."
                />
              )}
            </div>
          ) : (
            <CardContent className={classes.content}>
              <Typography variant="h5" gutterBottom>
                Başlandı Durumunda fişiniz olmadıgı için formunuz
                açılamadı.Lütfen ilgili fişinizi başlandı durumuna getiriniz!...
              </Typography>
            </CardContent>
          )}
        </Card>
      </Container>
    </Page>
  );
}

export default InstallForm;
